import axios from 'axios';
import {
    handle
} from 'redux-pack';
import { authURL } from './index';

// Actions
export const TOKEN = 'AUTH_TOKEN';

const initialState = {
    token: undefined,
    isLoading: false,
    hasError: false
};
export default function (state = initialState, action) {
    switch (action.type) {
        case TOKEN:
            return handle(state, action, {
                start: prevState => ({
                    ...prevState,
                    isLoading: true,
                    token: undefined
                }),
                success: (prevState, { payload: token }) => ({
                    ...prevState,
                    token,
                    hasError: false
                }),
                failure: prevState => ({
                    ...prevState,
                    hasError: true
                }),
                finish: prevState => ({
                    ...prevState,
                    isLoading: false
                }),
            });
        default:
            return state;
    }
}

export const getToken = () => ({
    type: TOKEN,
    promise: axios(authURL)
        .then(({ data: { token } }) => token)
        .catch(() => null)
});
